module.exports = __webpack_public_path__ + "components/rewards-header/static/unlock-white-49bca7c3fa2317c0a681ef69eec56c59.svg";